import { parseAllowedApiUrl } from './validateApiUrl'

export function applyDebugSettingsFromQs() {
  if (typeof window === 'undefined') return
  const location = window.location.href
  const url = new URL(location)
  const apiUrl = url.searchParams.get('withAPIURL')
  const enableDebug = url.searchParams.get('enableDebug')
  let shouldRefreshUrl = false
  if (enableDebug) {
    if (enableDebug === 'true' || enableDebug === '1') {
      localStorage.setItem('enable-debug', 'true')
    } else {
      localStorage.removeItem('enable-debug')
    }
    shouldRefreshUrl = true
  }
  if (apiUrl) {
    const decoded = decodeURIComponent(apiUrl)
    const normalized = parseAllowedApiUrl(decoded)
    if (normalized) {
      localStorage.setItem('api-base-url', JSON.stringify(normalized))
    } else {
      // Reject attacker-controlled hosts. The param is still stripped below so
      // a crafted link doesn't linger in the address bar / get re-shared.
      console.warn(
        '[debug] ?withAPIURL ignored: host not on allowlist',
        decoded,
      )
    }
    shouldRefreshUrl = true
  }

  if (shouldRefreshUrl) {
    url.searchParams.delete('withAPIURL')
    url.searchParams.delete('enableDebug')
    window.history.replaceState({}, '', url.toString())
    window.location.reload()
  }
}
